export default {
  title: 'Angebot',
  sections: {
    offer_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Unser Angebot</div>Werden Sie Partnerunternehmen und Co-Unternehmer',
            text2: 'Unsere Lösungen für Schweizer <br/> Ingenieurunternehmen',
            image: '/seu/latest-assets/seu_37.jpg'
          }
        },
      }
    },
    offer_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Angebot'
          }
        }
      }
    },
    offer_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_34.jpg'
          }
        }
      }
    },
    offer_text_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Mit SEU</div>  bauen Sie Ihre Zukunft neu'
          }
        },
        field_two: {
          value: {
            text: 'Teil der SEU zu sein, heisst: auf Erfolg und Wachstum zu bauen. Aber auch: den Spirit Ihrer Firma zu erhalten.'
          }
        },
        field_three: {
          value: {
            text: 'Sie führen ein etabliertes Ingenieur-Unternehmen und suchen nach Lösungen für die Herausforderungen des Marktes (Fachkräftemangel, Kostendruck, Digitalisierung). Die Zukunft Ihres KMU liegt Ihnen am Herzen und Sie suchen Führungskräfte, die mit Ihnen am gleichen Strick ziehen. Als Unternehmer/in stellen Sie sich die Frage, wie Ihr KMU Innovation operativ umsetzen und damit auch in Zukunft wettbewerbsfähig bleiben kann. Ihre Führungskräfte sind hervorragende Fachexperten, aber keine Unternehmer oder haben nicht die finanziellen Möglichkeiten, Ihr Unternehmen zu übernehmen.'
          }
        },
      }
    },
    offer_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Angebot'
          }
        }
      }
    },
    offer_text_2_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Branchenlösungen <br/> Von Ingenieuren für </br> Ingenieure </div>'
          }
        },
        // field_two: {
        //   value: {
        //     text: 'Through centralization at Group level, the SEU enables sustainable solutions, efficient processes, significant cost savings, and optimized capacity utilization. In addition, it specifically promotes junior staff and has a positive magnetic effect on skilled workers.'
        //   }
        // },
        field_three: {
          value: {
            text: `
              Als Partnerunternehmen profitieren Sie in vielen Bereichen, darunter Cross-Selling-Möglichkeiten und Erweiterung des Leistungsspektrums, professionelle Personalrekrutierung und -entwicklung, Managementunterstützung in Administration und IT, gezieltes Marketing zur Neukundengewinnung sowie die Nutzung etablierter Offshore-Produktionsstätten.
            `,
            text2: 'Auf den Punkt gebracht: Ihr Engineering-Unternehmen profitiert von spürbaren Synergieeffekten.'
          }
        },
      }
    },
    offer_features_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                name: 'Personalentwicklung',
                image: '/seu/latest-assets/seu_08.jpg',
                title: 'Mitarbeitende stärken und fördern',
                subTitle: `Wir unterstützen Sie als Partnerunternehmen bei der Gewinnung, Bindung und Weiterbildung Ihrer Fach- und Führungskräfte – durch die SEU Academy und das SEU-Mitarbeiterbeteiligungs-Programm.
<p>Ein Prozess mit Magnetwirkung: Durch die gezielte Förderung qualifizierter Mitarbeitender machen wir Ihr Unternehmen nicht nur wettbewerbsstark, sondern auch attraktiv für neue Fachkräfte. </p>
<p>Mitarbeitende sollen ihr Potenzial voll entfalten. Auf Wunsch dürfen Sie als <a class="text-highlight" href="/strategie#entrepreneur">Co-Unternehmer/innen</a> am Erfolg der SEU-Gruppe teilhaben. </p>
`,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
                id: 'succession'
              },
              {
                name: 'Management-Support',
                image: '/seu/latest-assets/seu_09.jpg',
                title: 'Beratung und Begleitung',
                subTitle: `Als Gruppe übernehmen wir gemeinsam Verantwortung für das Wachstum jedes einzelnen Partnerunternehmens und stehen dem Management dabei persönlich zur Seite. Im «daily business» helfen wir Ihnen, effiziente Strukturen und Prozesse für Verwaltung und Administration zu etablieren.
<p>Von Anfang an unterstützen wir Sie bei der sanften Integration in die SEU-Gruppe. Dabei behalten wir die Entwicklungen der nationalen und internationalen Branche im Auge, um Ihr Potenzial und Ihre Ressourcen bestmöglich zu fördern, zu vernetzen und weiterzuentwickeln.</p>`,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',

              },
              {
                name: 'Wachstum',
                image: '/seu/latest-assets/seu_14.jpg',
                title: 'Synergien nutzen und Ressourcen bündeln',
                subTitle: `
                 Durch die Grösse der SEU-Gruppe können Sie die Auslastung Ihrer Produktion erhöhen und erhalten bei Engpässen zuverlässige Entlastung.
                  <p>Durch die Integration weiterer Partnerunternehmen erweitern wir ständig unser Wissen und unterstützen Sie dabei, Ihre Produkte, Dienstleistungen und Geschäftsprozesse laufend zu optimieren, um kontinuierlich zu wachsen. Darüber hinaus sorgen wir dafür, dass digitale Tools gemeinsam genutzt und weiterentwickelt werden.</p>
                `,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
                id: 'management_support'
              },
              {
                name: 'Digitalisierung',
                image: '/seu/latest-assets/seu_10.jpg',
                title: 'Schlanke und effiziente Prozesse',
                subTitle: `Wo auch immer Ihr Unternehmen gerade steht: Wir sind Sparring-Partner zu allen Fragen der digitalen Transformation.
                  <p>Durch den Einsatz digitaler Services und Technologien optimieren wir gemeinsam die Wettbewerbsfähigkeit jedes einzelnen Partnerunternehmens. Geschäftsprozesse gestalten wir dabei schlanker, effizienter und noch zukunftsfähiger. Dabei setzen wir auch auf die neuesten Entwicklungen im Bereich KI und Machine Learning.</p>
                `,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
                id: 'digitalization'
              },
              {
                name: 'Neukundengewinnung',
                image: '/seu/latest-assets/seu_11.jpg',
                title: 'Cross-Selling und neue Märkte',
                subTitle: `Wir ermöglichen Ihnen die Erweiterung Ihres Kundenportfolios und die Erschliessung neuer Zielgruppen, Absatzgebiete und Kundensegmente.
                  <p>Wir unterstützen Sie bei der Entwicklung massgeschneiderter Cross-Selling-Strategien, um Ihre Potenziale voll auszuschöpfen. Darüber hinaus helfen wir Ihnen, auch grössere Projekte erfolgreich abzuschliessen, indem wir gemeinsam Ihr Leistungsangebot erweitern und Sie dadurch agiler und flexibler machen.</p>
                `,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                name: 'Marketing und Vertrieb',
                image: '/seu/latest-assets/seu_12.jpg',
                title: 'Strategien nach innen und aussen',
                subTitle: `
                  Unsere Expertise in den Bereichen Marketing, Kommunikation, Vertrieb und Employer Branding steht Ihnen uneingeschränkt zur Verfügung.
                  <p>Wir analysieren Synergiepotenziale für eine starke Präsenz in den digitalen Kanälen und unterstützen Sie bei der Strategieentwicklung für Social Media.</p>
                `,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                name: 'Offshore-Produktion',
                image: '/seu/latest-assets/seu_13.jpg',
                title: 'Effizienz und Schlagkraft',
                subTitle: `
                Die gemeinsame Nutzung der vorhandenen und etablierten Offshore-Produktionsstätten ist ein Gewinn für jedes Projekt und ein Mehrwert auf lange Sicht.
                <p>Sie senkt Produktionskosten spürbar und zuverlässig. Gleichzeitig hilft sie, den Fachkräftemangel besser zu bewältigen. Ein starkes Argument für Ihre Wettbewerbsfähigkeit.</p>
                `,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                name: 'Wirtschaftliche Sicherheit',
                image: '/seu/latest-assets/seu_15.jpg',
                title: 'Finanzierung, Kostenreduktion und Wachstum',
                subTitle: `
                 Durch Ertragssteigerung und Kostensenkung optimieren wir das Geschäftsergebnis. Dies wird durch Skaleneffekte, verbesserte Einkaufskonditionen, gemeinsame Prozessoptimierung und gezielte Auslandsproduktion erreicht.
                    <p>Zahlreiche Synergieeffekte innerhalb der SEU-Gruppe unterstützen Sie dabei, Ihre Kennzahlen zu erreichen.</p>
                `,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                name: 'Nachfolgelösungen',
                image: '/seu/latest-assets/seu_07.jpg',
                title: 'Individuell und zukunftsweisend',
                subTitle: `Wir unterstützen Sie als Partnerunternehmen bei der Identifikation, Auswahl und Entwicklung geeigneter Nachfolger/innen. Sie haben bereits einen Wunschkandidaten oder eine Wunschkandidatin – aber es fehlen die notwendigen finanziellen Mittel für eine Übernahme? Durch die Integration in die Gruppe schaffen wir Freiraum für die personelle Besetzung des zukünftigen Managements.
<p> Gemeinsam arbeiten wir daran, ein inhaberunabhängiges Management zu etablieren und eine gesunde, langfristige Unternehmensstrategie zu definieren und umzusetzen. </p>`,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
                id: 'economic_security'
              },
            ]
          }
        }
      }
    },
    offer_divider3_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Angebot'
          }
        }
      }
    },
    offer_text_3_section: {
      fields: {
        field_one: {
          value: {
            text: 'Vom Inhaber zum Co-Unternehmer. Von der Gründerin zur Co-Unternehmerin. <div class="text-highlight"><br/>Das haben Sie sich verdient.</div>'
          }
        },
        field_two: {
          value: {
            text: 'Sie können aufatmen: Ihr Einsatz hat sich rentiert, das Erreichte hat Bestand. Ihr Unternehmen operiert auch weiterhin eigenständig und unter gewohntem Namen. Das ist Ihr Verdienst.',
          }
        },
        field_three: {
          value: {
            text: 'Vor allem aber ist es schön, Sie weiterhin an Bord zu haben. Denn Sie kennen Ihr Unternehmen am besten, stehen für Beständigkeit und Werte und schaffen Vertrauen.',
            text2: 'Als Partner der SEU profitieren Sie von unserer Grösse, Professionalität und Innovationskraft, ohne Ihre unternehmerische Unabhängigkeit einzubüssen. Kunden und Mitarbeitende geniessen Kontinuität, während Sie als Co-Unternehmer/in in die SEU investieren und am gemeinsamen Erfolg partizipieren.',
            text3: 'Unser breites Produkt- und Service-Portfolio unterstützt Sie und ermöglicht Cross-Selling-Möglichkeiten. Freuen Sie sich auf individuelle Entwicklungsperspektiven für Ihre Mitarbeitenden und die Chance, die Zukunft der SEU-Gruppe aktiv mitzugestalten.'
           }
        },
      }
    },
    offer_divider4_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Angebot'
          }
        }
      }
    },
    offer_call_to_action_section: {
      fields: {
        field_one: {
          value: {
            text: 'Sie haben Fragen zu den einzelnen Schritten der Transaktion?',
            text2: 'Gerne beantworten wir diese in einem persönlichen Gespräch.',
            buttonLabel: 'Wir beraten Sie gerne',
            buttonLink: '/kontakt'
          }
        },
      }
    },
    offer_text_4_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight">Partnerunternehmen</div> auf Augenhöhe werden'
          }
        },
        field_two: {
          value: {
            text: 'So einzigartig wie Ihre Firma: Strategische und operative Synergieeffekte'
          }
        },
        field_three: {
          value: {
            text: 'Als unser Partnerunternehmen profitieren Sie von der Grösse, der Professionalität, dem Innovationsgeist und der Schlagkraft der SEU - und dies bei nahezu uneingeschränkter unternehmerischer Unabhängigkeit. Die Gruppe unterstützt Sie mit einem breiten und gut diversifizierten Produkt- und Dienstleistungsportfolio und ermöglicht Cross-Selling.'
          }
        },
        field_four: {
          value: {
            text: 'Für Ihre Kunden ändert sich nichts. Ihre Marke, Ansprechpersonen und Geschäftsführung der einzelnen Partnerunternehmen bleiben erhalten. Den Mitarbeitenden bietet SEU individuelle Perspektiven zur Weiterentwicklung.',
          }
        },
      }
    },
    offer_call_to_action_2_section: {
      fields: {
        field_one: {
          value: {
            text: 'Bereit?',
            text2: 'Werden Sie Teil von Swiss Engineers United.',
            buttonLabel: 'Wir freuen uns auf Sie',
            buttonLink: '/wir',
            image: '/seu/latest-assets/seu_20.jpg',
          }
        },
      }
    },
  }
}
